module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "full",
    attrs: {
      "id": "dashboard"
    }
  }, [(_vm.heroImg) ? _c('section', {
    staticClass: "full block heroImage",
    style: ({
      backgroundImage: 'url(' + _vm.heroImg + ')'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('CatalogueWidget', {
    attrs: {
      "item-list": _vm.itemList,
      "swiper-option": _vm.swiperOption
    }
  }), _vm._v(" "), (_vm.hasPlanobuilderRights) ? _c('PlanoWidget', {
    attrs: {
      "swiper-option": _vm.swiperOption
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemsStar.length) ? _c('StarredItemsWidget', {
    attrs: {
      "item-list": _vm.itemsStar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasOrderRights) ? _c('MyOrdersWidget') : _vm._e(), _vm._v(" "), (_vm.hasForecastAccess) ? _c('ForecastWidget') : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('duplicate', {
    key: _vm.showModal,
    attrs: {
      "show": _vm.showModal,
      "currentPlanoCampaign": _vm.currentPlanoCampaign,
      "currentPlanoZone": _vm.currentPlanoZone,
      "currentPlanoId": _vm.currentPlanoId,
      "currentPlanoName": _vm.currentPlanoName
    },
    on: {
      "close": function($event) {
        _vm.showModal = false;
      }
    }
  }), _vm._v(" "), (_vm.showModalComment) ? _c('Comment', {
    key: _vm.showModalComment,
    on: {
      "closeModal": function($event) {
        _vm.modalClose($event);
      }
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1663747f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = 3034
// module chunks = 0